import { render, staticRenderFns } from "./PerformanceRevenueList.vue?vue&type=template&id=24aac183&scoped=true"
import script from "./PerformanceRevenueList.vue?vue&type=script&lang=js"
export * from "./PerformanceRevenueList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aac183",
  null
  
)

export default component.exports